<span [matTooltip]="tooltip" class="{{ className }}" position="top">
  {{ readableValue }}
</span>
